export default __webpack_public_path__ + "static/media/sentro-login.dd5fa9bb.jpg";